export const SET_PANEL_TITLE = 'SET_PANEL_TITLE';
